import { makeStyles } from '@material-ui/core/styles';
import React, { Fragment } from 'react';

function cleanPhone(phone: string) {
  return phone.replace(/[^\d]/g, '');
}

function getValidNumber(phone: string) {
  if (phone.length === 10 || phone.length === 11) return `55${phone}`;

  return phone;
}

function formatPhone(phone: string) {
  if (phone.length < 10) return phone;
  return phone.replace(/^(\d{2})(\d{4,5})(\d{4}).*/, '($1) $2-$3');
}

const styles = makeStyles(() => ({
  root: {
    color: '#28a745',
    textDecoration: 'underline',
  },
}));

type WhatsAppLinkProps = {
  phone: string;
  children?: React.ReactNode;
  stylesProps?: string;
};

const WhatsAppLink = ({ phone, children, stylesProps }: WhatsAppLinkProps) => {
  const classesRoot = styles().root;

  if (phone?.includes('***')) return <>{phone}</>;

  const isNewFormat = phone?.startsWith('+');
  const isBrazilianPhone = phone?.startsWith('+55') || phone?.startsWith('55');

  if (isNewFormat && !isBrazilianPhone) return <>{phone}</>;

  const cleanPhoneValue = cleanPhone(phone);
  const phoneValue = isBrazilianPhone ? cleanPhoneValue.replace('55', '') : cleanPhoneValue;

  if (isBrazilianPhone) {
    return (
      <a
        href={`https://api.whatsapp.com/send?phone=${getValidNumber(phoneValue)}`}
        target='_blank'
        rel='noopener noreferrer'
        className={stylesProps ?? classesRoot}
      >
        {children ? children : formatPhone(phoneValue)}
      </a>
    );
  }

  return <>{children ? children : `${phoneValue.includes('+') ? '' : '+'}${phoneValue}`}</>;
};

export default WhatsAppLink;
